// theme-sources/js/sections/announcement-bar.js

import Swiper from "swiper";
import { Autoplay } from "swiper/modules";

const DEBUG = false;
const logger = {
  info(message, payload) {
    if (typeof window === "undefined") return;
    if (window.__ZIGGY_DEBUG__ !== true) return;
    if (!DEBUG) return;
    console.info(`[AnnouncementBar] ${message}`, payload ?? "");
  },
};

function initVerticalSwipers(root = document) {
  root.querySelectorAll("[data-announcement-bar]").forEach(initOne);
}

function initOne(el) {
  if (el._verticalSwiper) return;

  logger.info("init");

  const swiper = new Swiper(el, {
    modules: [Autoplay],
    loop: true,
    direction: "vertical",
    shortSwipes: false,
    speed: 600,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
  });

  el._verticalSwiper = swiper;
}

initVerticalSwipers();
